<template>
  <div class="dropzone-controls" v-show="items.length > 0">
    <div class="row">
      <div class="small-6 columns padding-R">
        <a class="button cta small block warning" href="javascript:;" @click="clearMap">CLEAR MAP</a>
      </div>
      <!-- <div class="small-4 columns padding-L padding-R">
        <a :class="['button cta small block', {disabled: items.length < 2}]" href="javascript:;" @click="processCalculate">
          <span v-if="!calculating">Calculate RUN</span>
          <span v-else><i class="fas fa-spinner fa-spin fa-fw"></i>Calculating . . .</span>
        </a>
      </div> -->
      <div class="small-6 columns padding-L">
        <a :class="['button cta small block success', {disabled:issueList.indexOf('not-allowed') > -1}]" href="javascript:;" @click="savePackage">SAVE RUN</a>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'dropzone-controls',
  data () {
    return {
      issueList: []
    }
  },
  computed: {
    runs () { return this.$store.state.runs },
    items () { return this.runs.dropzone.items },
    hereMaps () { return this.runs.hereMaps },
    calculating: {
      get () { return this.runs.dropzone.calculatingRun },
      set (x) { this.$store.commit('runs/setDropzoneData', {calculatingRun: x})}
    }
  },
  methods: {
    removeDuplicates (items) {
      return items.filter((item, index, self) => {
        return index === self.findIndex(p => (
          p.reservationID === item.reservationID && p.reservationID === item.reservationID
        ))
      })
    },
    clearMap () { this.$store.commit('runs/clearDropzone') },
    processCalculate () {
      if (this.items.length < 1) return
      let locs = []
      this.items.forEach((item, index) => {
        if (index === this.items.length - 1) return
        locs.push({
          id: item.id,
          origin: item.dropoff,
          destination: this.items[index + 1].pickup
        })
      })
      this.calculating = true
      this.calculateRun(locs)
    },
    calculateRun (locs) {
      let self = this
      if (!locs.length) {
        this.calculating = false
        return
      }

      let router = self.hereMaps.platform.getRoutingService(null, 8)
      let routeRequestParams = {
        routingMode: 'fast',
        transportMode: 'car',
        origin: `${locs[0].origin.lat},${locs[0].origin.lng}`,
        destination: `${locs[0].destination.lat},${locs[0].destination.lng}`,
        return: 'polyline,turnByTurnActions,actions,instructions,travelSummary'
      }

      router.calculateRoute(
        routeRequestParams,
        success => {
          let timeToNext = success.routes[0].sections[0].travelSummary.duration || 0
          if (timeToNext) {
            // timeToNext += 60 * 10 // add 30mins to ETA
          }
          self.$store.commit('runs/updateNextInfo', {
            id: locs[0].id,
            timeToNext: timeToNext,
            distanceToNext: parseFloat(((success.routes[0].sections[0].travelSummary.length || 0) / 1609).toFixed(2))
          })
          locs.shift()
          self.calculateRun(locs)
        },
        error => {
          console.log('error', error)
          locs.shift()
          self.calculateRun(locs)
        }
      )
    },
    savePackage () {
      let self = this

      if (self.issueList.indexOf('not-allowed') > -1) return

      let rsvpGapTime = self.$settings.get('ReservationGapTime')
      let hasError = false
      let errorMsg = ''
      self.items.forEach((item, i) => {
        if (i + 1 >= self.items.length) return

        let arrivalTime = moment(item.pickupDate, 'MM/DD/YYYY hh:mmA').add(item.eta, 'seconds').add(item.timeToNext || 0, 'seconds')
        let currentTrip = moment(item.pickupDate, 'MM/DD/YYYY hh:mmA').add(item.eta, 'seconds')
        let nextPickup = moment()
        if (self.items[i + 1]) {
          nextPickup = moment(self.items[i + 1].pickupDate, 'MM/DD/YYYY hh:mmA')
        }
        /*
        if (currentTrip.diff(nextPickup, 'minutes') > -rsvpGapTime) {
          hasError = true
          errorMsg = `There should be at least <b>${rsvpGapTime} mins</b> gap between trips.`
        } else if (i != (self.items.length - 1) && arrivalTime.isAfter(nextPickup)) {
          hasError = true
          errorMsg = 'Not enough time to reach the next pickup.'
        }
        */
      })
      if (hasError) {
        self.$store.commit('global/setAlertData', {
          show: true,
          message: errorMsg
        })
        return
      }

      self.$store.commit('routing/showRoutingModal')

      let message = 'Are you sure you want to save this run?'
      let action = 'SAVE_RUN'
      self.$store.commit('routing/setConfirmationModal', {
        show: true,
        title: 'Confirm Run',
        message: message,
        action: action
      })
    },
    updateIssue (x) {
      this.issueList = x
    }
  }
}
</script>

<style lang="scss" scoped>
.dropzone-controls {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  border-top: 1px solid rgba(0,0,0,0.3);
  padding: 15px 10px;
}

.row{ padding: 0 10px; }
.padding-L { padding-left: 5px; }
.padding-R { padding-right: 5px; }

.button{
  line-height: 135%;
}

@media screen and (max-width: 430px) {
  .dropzone-controls {
    bottom: 45px;
    padding: 10px 0;
    .button.small {
      font-size: 12px;
      padding: 10px 7px 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Runs/DropzoneControls.vue